import { useEffect, useState } from "react";
import { Menu, X, Sun, Moon } from "lucide-react";
import { NAV_LINKS } from "../../data/content";

export const Navbar = () => {
  const [theme, setTheme] = useState("light");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [active, setActive] = useState("about");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { threshold: 0.3 }
    );
    sections.forEach((s) => obs.observe(s));
    return () => obs.disconnect();
  }, []);

  const go = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <nav className="nav" aria-label="Primary navigation">
        <div className="nav-inner">
          <a href="#about" className="nav-logo" data-testid="nav-logo"
             onClick={(e) => { e.preventDefault(); go("#about"); }} aria-label="Augustus Emenogu home">
            <div className="nav-logo-mark" aria-hidden="true">AE</div>
            <span>Augustus Emenogu</span>
          </a>
          <ul className="nav-links" role="list">
            {NAV_LINKS.map(([href, label]) => (
              <li key={href}>
                <a href={href}
                   className={active === href.slice(1) ? "active" : ""}
                   data-testid={`nav-link-${label.toLowerCase()}`}
                   onClick={(e) => { e.preventDefault(); go(href); }}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
          <div className="nav-actions">
            <button className="theme-toggle" data-testid="theme-toggle"
                    onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
                    aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}>
              {theme === "dark" ? <Moon size={16} /> : <Sun size={16} />}
            </button>
            <a href="#contact" className="btn-contact" data-testid="nav-contact-btn"
               onClick={(e) => { e.preventDefault(); go("#contact"); }}>Get in Touch</a>
            <button className="nav-mobile-toggle" data-testid="mobile-menu-toggle"
                    aria-label="Open menu" aria-expanded={mobileOpen}
                    onClick={() => setMobileOpen((o) => !o)}>
              {mobileOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </nav>

      <div className={`mobile-menu ${mobileOpen ? "open" : ""}`} id="mobile-menu" role="dialog" aria-label="Navigation menu">
        {NAV_LINKS.map(([href, label]) => (
          <a key={href} href={href} onClick={(e) => { e.preventDefault(); go(href); }}>{label}</a>
        ))}
        <a href="#contact" style={{ color: "var(--primary)", fontWeight: 600 }}
           onClick={(e) => { e.preventDefault(); go("#contact"); }}>Get in Touch</a>
      </div>
    </>
  );
};
